import query from "devextreme/data/query";
import * as glb from "./globals";
import languageData from "./languageData";

export default class Dict {
    static get(key, lang) {
        // Önce languageData.js'den çeviri ara
        let currentLang = lang || (glb.default.KULLANICI && glb.default.KULLANICI.KUL_DILKOD) || 'tr';
        // Eğer parametre ile farklı bir dil seçildiyse controller'daki bilgiyi de güncelle
        if (lang && glb.default.KULLANICI) {
            glb.default.KULLANICI.KUL_DILKOD = lang;
        }
        if (languageData[key] && languageData[key][currentLang]) {
            return languageData[key][currentLang] || key;
        }
        // Eski davranış: dictLkp (DB'den)
        var result = query(glb.default.dictLkp).filter(x => x.keyword === key).toArray();
        if (result && result.length > 0) {
            return result[0].descword;
        } else {
            return key;
        }
    }
}